module.exports = "./img/desktop_logo.7019318.png";